import React, { useState, useContext } from 'react'
import PropTypes from "prop-types"
import moment from "moment"
import { RichText } from 'prismic-reactjs'
import { ThemeProvider } from "styled-components"
import Imgix from "react-imgix";

import { getLinkPropsFromMeta } from '../../utils/link'
import { RichLinks, RichContent } from '../../utils/html'
import { getFormattedLocalizedDate } from '../../utils/time'

import ConfigurationContext from '../../context/configuration-context';

import { getTheme } from '../../theme/theme'
import { getImageSizes } from '../../theme/grid'
import { margin, SIZE } from '../../theme/metrics'

import Truncate from "../truncate";
import ResponsiveImage from '../responsive-image'

import { Container, ContainerInner, Inner, ContentContainer, Category, Meta, Published, Headline, Summary, ImageContainer, ImageInner, Image, ButtonList, ButtonListItem, Button } from './blog-cover.styles'


const BlogCover = ({category,headline,introduction,cover_image,cover_color,_meta}) => {
	const configuration = useContext(ConfigurationContext);

	return (
		<ThemeProvider theme={(theme) => ({...theme,...getTheme(cover_color)})}>
			<Container>
				<ContainerInner>
					<Inner>
						<ContentContainer>
							<Meta>
								{category && <Category {...getLinkPropsFromMeta(category._meta)}>{category.name}</Category>}
								<Published>{getFormattedLocalizedDate(_meta.firstPublicationDate,configuration)}</Published>
							</Meta>
							{headline && <Headline><RichContent render={headline} /></Headline>}
							<Summary>
								<Truncate>{introduction[0].text}</Truncate>
							</Summary>
							<Button filled="true" {...getLinkPropsFromMeta(_meta)}>{configuration.label_read_more}</Button>
						</ContentContainer>
						
						<ImageContainer>
							<ImageInner>
								{cover_image && <ResponsiveImage image={cover_image} fit="cover" sizes={{medium:{span:6},large:{span:5}}} sizeOptions={{defaultSize:`calc(100vw - ${margin(SIZE.small,{multiplier:2})})`}} />}
							</ImageInner>
						</ImageContainer>
						
					</Inner>
				</ContainerInner>
			</Container>
		</ThemeProvider>
	)
}

export default BlogCover;